import { MepEmissionsByMonth } from "../../../../../../../../models/mep/mep.models";
import * as Enumerable from "linq";
import { ChartLegendViewModel } from "../../../../common-vm/chart-legend-view-model";
import { LineChartHelper } from "../../../../common-vm/line-chart-helper";
import { ConditionalDecimalPlacesValueConverter } from "../../../../converters/conditional-decimal-places-value-converter";
import { EmissionSymbolValueConverter } from "../../../../converters/emission-symbol-value-converter";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
const am4core = await import("@amcharts/amcharts4/core");
const am4charts = await import("@amcharts/amcharts4/charts");
const am4themes_animated = (await import("@amcharts/amcharts4/themes/animated")).default;

export class MepEmissionsByMonthChartViewModel {
    //emissionsByMonthChart: any;
    legend: ChartLegendViewModel;
    scientificNotationConverter: ConditionalDecimalPlacesValueConverter = new ConditionalDecimalPlacesValueConverter();
    emissionSymbolConverter: EmissionSymbolValueConverter = new EmissionSymbolValueConverter();

    constructor(chartDivName: string, private year: number, private emissionsByMonth: MepEmissionsByMonth[], private configService: ConfigService) {
        this.initEmissionsByMonthChart(chartDivName);
    }

    initEmissionsByMonthChart(chartDivName: string) {

        /*
        [
            {
                month:'jan'
                Co2: 21213,
                VOC: 21234
            }
        ]
        */
        const yearLabel = "FY" + this.year;
        const dataForChart = Enumerable.from(this.emissionsByMonth).groupBy(x => x.emissionMonth)
            .select(x => {
                const item: any = {};
                item.calendarYear = x.first().calendarYear.toString();
                item.month = x.first().emissionMonthName.substring(0, 3);
                x.forEach(yearValueForMonth => {
                    item[yearLabel] = this.scientificNotationConverter.toView(yearValueForMonth.totalEmissionsQtyTonnes, null);
                });
                return item;
            });

        //Create chart instance 
        am4core.useTheme(am4themes_animated);
        am4core.addLicense(this.configService.config.settings.amChartsLicense);
        const chart = am4core.create(chartDivName, am4charts.XYChart);

        // Create category axes that will use the month property we created in dataForChart
        LineChartHelper.AddXCategoryAxis(chart, "month")
        const yAxis = LineChartHelper.AddYValueAxis(chart, 0);
        yAxis.extraMax = 0.03;
        yAxis.extraMin = 0;

        const dataItems = Enumerable.from(this.emissionsByMonth).groupBy(() => yearLabel);
        const legendData = dataItems.select(x => {
            return {
                id: x.first().emissionYear,
                name: `FY ${x.first().emissionYear}`
            }
        }).distinct(x => x.id).toArray();

        this.legend = new ChartLegendViewModel();
        this.legend.generateLegendItems(legendData);

        //We want to draw a line for each Year and the dots would then be the months thus we create a line series for each one
        dataItems.forEach((emission) => {
            const color = this.legend.getColor(emission.first().emissionYear);
            LineChartHelper.AddCategorySeries(chart, color, "month", emission.key(), `{categoryX} {calendarYear} : {${emission.key()}}`);
        });

        //use XY cursor to highlight all points 
        chart.cursor = new am4charts.XYCursor();

        if (this.emissionsByMonth.filter(x => x.totalEmissionsQtyTonnes < 0.001).length > 0) {
            chart.numberFormatter.numberFormat = "#.##e";
        } else {
            chart.numberFormatter.numberFormat = "#,###";
        }

        chart.data = Enumerable.from(this.emissionsByMonth).where(x => x.totalEmissionsQtyTonnes != 0).any() ? dataForChart.toArray() : [];

    }
}